import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import axios from "axios";
import { useLang } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function PaymentSuccess() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let attempts = 0;
    const poll = async () => {
      if (attempts++ > 8) { setState("timeout"); return; }
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setState("error"); return; }
      } catch {}
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div data-testid="payment-success-page" className="pt-16 min-h-screen flex items-center justify-center px-5">
      <div className="text-center max-w-md">
        {state === "checking" && (
          <>
            <Loader2 size={48} className="text-[#2E5A3B] mx-auto mb-6 animate-spin" />
            <p className="text-[#5C5C5C]">{t.payment.checking}</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 size={56} className="text-[#2E5A3B] mx-auto mb-6" />
            <h1 data-testid="payment-success-title" className="font-serif-d text-4xl font-semibold text-[#132A1D] mb-4">{t.payment.successTitle}</h1>
            <p className="text-[#5C5C5C] leading-relaxed mb-8">{t.payment.successMsg}</p>
          </>
        )}
        {(state === "error" || state === "timeout") && (
          <>
            <XCircle size={56} className="text-[#C86A4B] mx-auto mb-6" />
            <p className="text-[#5C5C5C] leading-relaxed mb-8">{t.payment.timeout}</p>
          </>
        )}
        {state !== "checking" && (
          <Link to="/catalogo" data-testid="payment-back-btn"
            className="inline-flex rounded-full bg-[#2E5A3B] text-white px-8 py-3 text-sm font-semibold hover:bg-[#C86A4B] transition-colors duration-300">
            {t.payment.back}
          </Link>
        )}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const { t } = useLang();
  return (
    <div data-testid="payment-cancel-page" className="pt-16 min-h-screen flex items-center justify-center px-5">
      <div className="text-center max-w-md">
        <XCircle size={56} className="text-[#C86A4B] mx-auto mb-6" />
        <h1 className="font-serif-d text-4xl font-semibold text-[#132A1D] mb-4">{t.payment.cancelTitle}</h1>
        <p className="text-[#5C5C5C] leading-relaxed mb-8">{t.payment.cancelMsg}</p>
        <Link to="/catalogo" data-testid="payment-cancel-back-btn"
          className="inline-flex rounded-full bg-[#2E5A3B] text-white px-8 py-3 text-sm font-semibold hover:bg-[#C86A4B] transition-colors duration-300">
          {t.payment.back}
        </Link>
      </div>
    </div>
  );
}
